export default function booleanConverter(value) {
  if (value === null || value === undefined || value.toString().trim() === '') return null;
  return value.toString().trim().toUpperCase() === 'OUI'
    || value.toString().trim().toUpperCase() === 'TRUE'
    || value.toString().trim().toUpperCase() === '1'
    || value.toString().trim().toUpperCase() === 'VRAI';
}
